import { ValidationType } from "src/enums";
import { Field, ValidationResult } from "src/models";
import { _ } from ".";
import { StringService } from "./string.service";

export namespace ValidationService {

    const cellRegex = /^(09[0-9]{9})$/;
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/;


    export const validate = (value: string, title: string, validationTypes: ValidationType[]): ValidationResult => {
        if (typeof value === 'string') value = StringService.normalize(value);

        // to check required first
        const sorted = validationTypes.sort();

        const result: ValidationResult = {
            message: null,
            valid: true
        };

        for (let vtype of sorted) {
            switch (vtype) {
                case ValidationType.Required:
                    if (!value || (typeof value === 'string' && !value.trim())) {
                        result.message = _("requiredMessage").replaceAll("{title}", title);
                        result.valid = false;
                    }
                    break;

                case ValidationType.Cell:
                    if (!value || !value.trim()) break;
                    if (!cellRegex.test(value)) {
                        result.message = _("cellRegexMessage").replaceAll("{title}", title);
                        result.valid = false;
                    }
                    break;
                case ValidationType.Email:
                    if (!value || !value.trim()) break;
                    if (!emailRegex.test(value)) {
                        result.message = _("emailRegexMessage").replaceAll("{title}", title);
                        result.valid = false;
                    }
                    break;
            }

            // no need for further validation
            if (!result.valid) break;
        }

        return result;
    };

    export const validatModelByIndex = (fields: Field[], target: number | null, value: string): { fields: Field[], valid: boolean } => {
        let m = [...fields];
        let modelValid = true;

        if (target !== null) {
            m[target].value = (value) || "";
        }

        m.forEach((x, index) => {

            if (target !== null && target !== index) return;
            const { message, valid } = validate(x.value, x.title, x.validations || []);
            x.error = message || "";
            if (!valid) modelValid = valid;

        });

        return { fields: m, valid: modelValid };
    };

    export const validateModelByName = (fields: Field[], target: string | null, value: any): { fields: Field[], valid: boolean } => {
        let m = [...fields];
        let modelValid = true;

        if (target !== null) {
            const field = fields.find((x) => x.name === target);
            field && (field.value = (value) || "");
        }

        m.forEach((x) => {

            if (target !== null && target !== x.name) return;
            const { message, valid } = validate(x.value, x.title, x.validations || []);
            x.error = message || "";
            if (!valid) modelValid = valid;

        });

        return { fields: m, valid: modelValid };
    };

    export const convetToDto = (fields: Field[]): any => {

        const model: any = {};

        fields.forEach((x) => {
            let value: any = null;
            value = StringService.normalize(StringService.normalize(x.value));
            if (value || value === 0) model[x.name] = value;
        });

        return model;

    };

}